export default "__VITE_ASSET__BDpKqwWe__"